/**
 * UI Store
 *
 * Global UI triggers that need to be callable from anywhere (hooks, services,
 * non-React modules) and observed by a single consumer in the component tree.
 *
 * Currently:
 * - `buyCreditsOpen`: drives the global BuyCreditsModal. Triggered when n8n's
 *   credit checker rejects an action (see InsufficientCreditsError in
 *   components/core/services/n8n.service.ts). Modal renders once at AppLayout
 *   level and listens to this flag.
 */

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface UIState {
  buyCreditsOpen: boolean;
  openBuyCredits: () => void;
  closeBuyCredits: () => void;
}

export const useUIStore = create<UIState>()(
  immer((set) => ({
    buyCreditsOpen: false,
    openBuyCredits: () =>
      set((state) => {
        state.buyCreditsOpen = true;
      }),
    closeBuyCredits: () =>
      set((state) => {
        state.buyCreditsOpen = false;
      }),
  })),
);

/**
 * Non-React accessor for triggering the Buy Credits modal from outside the
 * component tree (e.g. action hooks, service-layer catch blocks).
 */
export const openBuyCredits = () => useUIStore.getState().openBuyCredits();
export const closeBuyCredits = () => useUIStore.getState().closeBuyCredits();